import type { Environment } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteEnvironmentDialogProps {
  environment: Environment | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * The one confirm-delete idiom (UX polish wave 3 — `EnvironmentDetailPage`
 * used to hand-roll this inline; every sibling detail page uses a dedicated
 * `*Dialog` component, e.g. `DeleteInstanceDialog`). The server remains the
 * real gate (S-8): this only asks for confirmation before sending the
 * request — deletion is still refused server-side if the environment is
 * protected, still has machines attached, or is another environment's
 * promotion source.
 */
export function DeleteEnvironmentDialog({
  environment,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteEnvironmentDialogProps) {
  return (
    <Modal open={environment !== null} title={`Delete "${environment?.name}"?`} onClose={onCancel}>
      <p>
        This removes the environment. It is refused if the environment is protected, still has
        machines attached, or is another environment's promotion source.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" disabled={isDeleting} onClick={onConfirm}>
          {isDeleting ? "Deleting…" : "Delete environment"}
        </Button>
      </div>
    </Modal>
  );
}
